import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  repository = new DataTableRepository();
  revisiExportChannel = new Subject();
  inactiveEmployeeChannel = new Subject();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.revisiExportChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRowTable = async (query, cancelToken) => {
    try {
      this.rowtableChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchRevisiExport = async (query) => {
    try {
      this.revisiExportChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRevisiExport(query)
        .then((result) => {
          this.revisiExportChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.revisiExportChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchInactiveEmployee = async (query) => {
    try {
      this.inactiveEmployeeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchInactiveEmployee(query)
        .then((result) => {
          this.inactiveEmployeeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.inactiveEmployeeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
}

export default DataTableBloc;
